<template>
  <div class="index-data in">
    <div class="w1200 animate_top index-data-box">
      <div class="index-data-item" v-for="(item, index) in childItem.propsValue.data" :key="index">
        <div class="index-data-item-number">
          <h2
            class="timer count-title count-number"
            data-refresh-interval="50"
            data-to="5000"
            data-speed="2000"
            data-from="0"
          >
            {{item.customField1}}
          </h2>
          <span> {{item.customField2}}</span>
        </div>
        <p>{{item.customField3}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkLianghuashujuWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "数值",
          type: "text",
        },
        {
          code: "customField2",
          label: "单位",
          type: "text",
        },
        {
          code: "customField3",
          label: "描述",
          type: "text",
        },
      ],
      data: [
        {
          customField1: "5000",
          customField2: "+",
          customField3: "央、国企等大型集团企业用户",
        },
        {
          customField1: "30",
          customField2: "秒",
          customField3: "平均单据审核时长",
        },
        {
          customField1: "1",
          customField2: "天",
          customField3: "平均报销周期",
        },
        {
          customField1: "95",
          customField2: "%",
          customField3: "手工填写量减少",
        },
      ],
      max: 6,
      min: 4
    };
  },
};
</script>


<style lang="scss">
.index-data {
  padding-top: 70px;
  height: 240px;
}

.index-data-box {
  background: url(../../../../../assets/img/index-data-bg.png) #fff no-repeat
    center center;
  background-size: 100% 100% !important;
  width: 100%;
  height: 120px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .index-data-item {
    flex: 1;
    text-align: center;

    .index-data-item-number h2 {
      font-size: 38px;
      line-height: 20px;
      letter-spacing: 3px;
      display: inline-block;
      color: #e31924;
      font-family: Impact;
      margin: 0 auto;
    }
    .index-data-item-number span {
      font-size: 14px;
      letter-spacing: 2px;
      color: #e31924;
    }
    p {
      font-size: 12px;
      padding-top: 18px;
      color: #6c6c6c;
      margin: 0 auto;
    }
  }
}
</style>
